import { Directive, ElementRef, HostListener, inject, OnInit } from '@angular/core';

export const allowedKeys = ['Enter', 'Tab', 'Home', 'End', 'Backspace', 'Ins', 'Insert', 'Del', 'Delete',
  'Left', 'Right', 'ArrowLeft', 'ArrowRight', 'NumLock'];
export const copyPasteKeys = ['a', 'c', 'Insert', 'v', 'x', 'y', 'z'];

@Directive()
export abstract class InputFilterBaseDirective implements OnInit {
  protected abstract allowedKeyRegex: RegExp;
  protected abstract filterRegex: RegExp;

  private el = inject(ElementRef);

  ngOnInit(): void {
    if (this.el && this.el.nativeElement) {
      const allowedKeyRegex = this.allowedKeyRegex;
      this.el.nativeElement['onkeydown'] = function (event) {
        if (event.key) {
          const key = event.key.toLowerCase();
          // metaKey verification is needed for Cmd key from Mac
          const ctrlOrCmdKey = event.ctrlKey === true || event.metaKey === true;
          // Ctrl+A (Select all), Ctrl+C / Ctrl+Insert (Copy), Ctrl+V (Paste), Ctrl+X (Cut), Ctrl+Y (Redo), Ctrl+Z (Undo)
          const controlKeyShortcuts = ctrlOrCmdKey && (copyPasteKeys.indexOf(key) > -1);

          const shiftKey = event.shiftKey;
          // Shift+Insert (Paste) - alternative to Ctrl+V
          const pasteShortcut = shiftKey && key === 'insert';
          // Ctrl+Shift+Z (Redo) - alternative to Ctrl+Y
          const redoShortcut = ctrlOrCmdKey && shiftKey && key === 'z';

          const isAllowedChar = allowedKeyRegex.test(event.key);

          if (!isAllowedChar && allowedKeys.indexOf(event.key) < 0 && !controlKeyShortcuts && !pasteShortcut && !redoShortcut) {
            event.preventDefault();
          }
        }
      };
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();

    const pastedText = event.clipboardData?.getData('text/plain') || '';
    const filtered = pastedText.replace(this.filterRegex, '');

    const inputElement = this.el.nativeElement as HTMLInputElement;
    const start = inputElement.selectionStart || 0;
    const end = inputElement.selectionEnd || 0;

    const currentValue = inputElement.value;
    inputElement.value = currentValue.substring(0, start) + filtered + currentValue.substring(end);

    // Dispatch an 'input' event to notify Angular's form controls
    inputElement.dispatchEvent(new Event('input'));
  }

  @HostListener('input', ['$event'])
  onInputChange(event) {
    if (event && event.target && event.target.value) {
      const inputValue = event.target.value;
      event.target.value = inputValue.replace(this.filterRegex, '');

      if (inputValue !== event.target.value) {
        event.stopPropagation();
      }
    }
  }
}

